import React from 'react';
import { useParams } from 'react-router-dom';
import {
    Grid,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    CircularProgress,
    TableContainer
} from '@material-ui/core';
import { useSwaggerClient } from '../../../../hooks/useSwaggerClient';
import AdminHeader from '../../../../components/atom/AdminHeader';

function ChainCompaniesTable() {
    const { chainId } = useParams();
    const [chain, loading, error] = useSwaggerClient('chains', 'getChainById', {
        chainId: parseInt(chainId, 10)
    });

    if (error) {
        return (
            <Grid container justifyContent="center">
                <h1>{error}</h1>
            </Grid>
        );
    }
    if (loading) {
        return (
            <Grid container justifyContent="center">
                <CircularProgress />
            </Grid>
        );
    }
    return (
        <Grid container spacing={2}>
            <AdminHeader title={`Companies in chain: ${chain?.name}`} />
            <Grid item xs={12}>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Vendor / Client</TableCell>
                                <TableCell>URL</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {chain.companies.map((company, index) => (
                                <TableRow
                                    // eslint-disable-next-line react/no-array-index-key
                                    key={index}
                                >
                                    <TableCell>{company.name}</TableCell>
                                    <TableCell>
                                        {typeof company.contact_email?.reservation === 'string' &&
                                        company.contact_email.reservation.trim() !== ''
                                            ? company.contact_email.reservation.split(',')
                                                  .length === 1
                                                ? company.contact_email.reservation
                                                : `${
                                                      company.contact_email.reservation.split(
                                                          ','
                                                      )[0]
                                                  } and ${company.contact_email.reservation.split(
                                                      ','
                                                  ).length - 1} other(s)`
                                            : ''}
                                    </TableCell>
                                    <TableCell>{`${company.is_vendor ? 'Vendor ' : ''}${
                                        company.is_client ? 'Client' : ''
                                    }`}</TableCell>
                                    <TableCell>{company.client_url}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            {chain.companies?.length === 0 && (
                <Grid item xs={12}>
                    <h4>Chain without company.</h4>
                </Grid>
            )}
        </Grid>
    );
}

export default ChainCompaniesTable;
